@let selectedRecords = selectedRecordsSg();
@let assignableRecords = assignableRecordsSg();
@let isSubmitting =
  assignedEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();
@let isLoading =
  assignableEc.plugins.currentListPlugin.feature.selectors.isLoading.asSignal();

<atn-ds-centered-overlay type="wide">
  <div class="atn-space-assign-labs-to-lab-service-modal">
    <atn-ds-widget title="Add Laboratories">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-space-assign-labs-to-lab-service-modal__content">
        <!-- Filters -->
        <div class="atn-space-assign-labs-to-lab-service-modal__filters">
          <!-- Campus / Building / Floor filter dropdowns (leaf entity excluded) -->
          <atn-space-dimension-filter
            [plugin]="dimensionFilterPlugin"
            [excludeLeaf]="true"
          />

          <!-- Department filter (independent of the space dimension) -->
          <atn-ds-select-multiple
            label="Department"
            placeholder="Select department"
            [config]="{
              overlay: {
                minSearchCharacters: 1,
                hasSearch: true,
              },
            }"
            [items]="departmentOptionsSg()"
            [value]="orgFilterSg()?.recordIds ?? []"
            (valueChange)="onDepartmentChange($event)"
          />

          <!-- Responsible Person filter (independent of the space dimension) -->
          <atn-space-dimension-filter
            [plugin]="responsiblePersonFilterPlugin"
            label="Responsible Person"
          />

          <!-- Cluster filter (independent of the space dimension) -->
          <atn-space-dimension-filter [plugin]="clusterDimensionFilterPlugin" />
        </div>

        <!-- Records section: header + selected tags + checkbox list -->
        <div class="atn-space-assign-labs-to-lab-service-modal__records">
          <div class="atn-space-assign-labs-to-lab-service-modal__header">
            <span
              ><b>{{ recordTitleSg() }}</b></span
            >
          </div>
          <div
            class="atn-space-assign-labs-to-lab-service-modal__selection-section"
          >
            @if (selectedRecords.length > 0) {
              <div class="atn-space-assign-labs-to-lab-service-modal__selected">
                @for (record of selectedRecords; track record.id) {
                  <atn-ds-tag
                    [text]="getRecordLabel(record)"
                    (close)="removeSelectedRecord(record.id)"
                  />
                }
              </div>
            }

            <div class="atn-space-assign-labs-to-lab-service-modal__rooms">
              @if (isLoading) {
                <div
                  class="atn-space-assign-labs-to-lab-service-modal__rooms-loading"
                >
                  <atn-ds-loader />
                </div>
              } @else {
                @for (record of assignableRecords; track record.id) {
                  <div class="atn-space-assign-labs-to-lab-service-modal__row">
                    <atn-ds-checkbox
                      [selected]="isRecordSelected(record.id)"
                      (selectedChange)="
                        recordCheckboxChangedHandler(record.id, $event)
                      "
                      [label]="getRecordLabel(record)"
                    />
                  </div>
                } @empty {
                  <div
                    class="atn-space-assign-labs-to-lab-service-modal__rooms-empty"
                  >
                    No records available
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>

      <div
        class="atn-space-assign-labs-to-lab-service-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button
          (click)="saveClickHandler()"
          [disabled]="!selectedRecords.length"
          [loading]="isSubmitting"
        >
          Save
        </atn-ds-button>
      </div>
    </atn-ds-widget>
  </div>
</atn-ds-centered-overlay>
